import { Box, Container } from '@chakra-ui/react';
import { Fade } from 'react-awesome-reveal';
import NewHomeStats from '../../components/NewHome/NewHomeStats/NewHomeStats';
import NewHomeTrend from '../../components/NewHome/NewHomeTrend/NewHomeTrend';
import NewHomeBrandList from '../../components/NewHome/NewHomeBrandList/NewHomeBrandList';

import hypex from '../../assets/image/home/partners/hypex.png';
import hypexM from '../../assets/image/home/partners/hypex_m.png';
import polygon from '../../assets/image/home/partners/polygon.png';
import galxe from '../../assets/image/home/partners/galxe.png';
import galxeM from '../../assets/image/home/partners/galxe_m.png';
import bitmart from '../../assets/image/home/partners/bitmart.png';
import bitmartM from '../../assets/image/home/partners/bitmart_m.png';
import binance from '../../assets/image/home/partners/binance.png';
import metaera from '../../assets/image/home/partners/metaera.png';
import metaeraM from '../../assets/image/home/partners/metaera_m.png';
import tokenPocket from '../../assets/image/home/partners/token-pocket.png';
import tokenPocketM from '../../assets/image/home/partners/token-pocket_m.png';
import chainCatcher from '../../assets/image/home/partners/chain-catcher.png';
import chainCatcherM from '../../assets/image/home/partners/chain-catcher_m.png';
import gold from '../../assets/image/home/partners/gold.png';
import goldM from '../../assets/image/home/partners/gold_m.png';
import imToken from '../../assets/image/home/partners/im-token.png';
import imTokenM from '../../assets/image/home/partners/im-token_m.png';
import walletConnect from '../../assets/image/home/partners/wallet-connect.png';
import walletConnectM from '../../assets/image/home/partners/wallet-connect_m.png';

import polygon_m from '../../assets/image/home/partners/Polygon_m.png';
import binance_m from '../../assets/image/home/partners/BSCchain_m.png';

import NewHomeNews from '../../components/NewHome/NewHomeNews/NewHomeNews';
import NewHomeAssistant from '../../components/NewHome/NewHomeAssistant/NewHomeAssistant';
import NewHomeBanner from '../../components/NewHome/NewHomeBanner/NewHomeBanner';

const PARTNERS = [
  { name: 'hypex', image: hypex, image_m: hypexM, link: '' },
  { name: 'binance', image: binance, image_m: binance_m, link: 'https://www.bnbchain.org/en/bnb-smart-chain' },
  { name: 'galxe', image: galxe, image_m: galxeM, link: 'https://www.galxe.com/' },
  { name: 'polygon', image: polygon, image_m: polygon_m, link: 'https://polygon.technology/' },
  { name: 'bitmart', image: bitmart, image_m: bitmartM, link: 'https://www.bitmart.com/' },
  { name: 'metaera', image: metaera, image_m: metaeraM, link: 'https://www.metaera.hk/' },
  { name: 'token-pocket', image: tokenPocket, image_m: tokenPocketM, link: 'https://www.tokenpocket.pro/' },
  { name: 'chain-catcher', image: chainCatcher, image_m: chainCatcherM, link: 'https://www.chaincatcher.com/' },
  { name: 'gold', image: gold, image_m: goldM, link: 'https://www.jinse.cn/' },
  { name: 'imToken', image: imToken, image_m: imTokenM, link: 'https://token.im/' },
  { name: 'wallet-connect', image: walletConnect, image_m: walletConnectM, link: 'https://walletconnect.network/' },
  //
  { name: 'hypex_rep1', image: hypex, link: '' },
  { name: 'binance_rep1', image: binance, link: 'https://www.bnbchain.org/en/bnb-smart-chain' },
  { name: 'galxe_rep1', image: galxe, link: 'https://www.galxe.com/' },
  { name: 'polygon_rep1', image: polygon, link: 'https://polygon.technology/' },
  { name: 'bitmart_rep1', image: bitmart, link: 'https://www.bitmart.com/' },
  { name: 'metaera_rep1', image: metaera, link: 'https://www.metaera.hk/' },
  { name: 'token-pocket_rep1', image: tokenPocket, link: 'https://www.tokenpocket.pro/' },
  { name: 'chain-catcher_rep1', image: chainCatcher, link: 'https://www.chaincatcher.com/' },
  { name: 'gold_rep1', image: gold, link: 'https://www.jinse.cn/' },
  { name: 'imToken_rep1', image: imToken, link: 'https://token.im/' },
  { name: 'wallet-connect_rep1', image: walletConnect, link: 'https://walletconnect.network/' }
];

const NewHome = () => {
  return (
    <Box width="100%">
      <NewHomeBanner />
      <Container maxW="100%" px={0} display="flex" flexDir="column" alignItems="center">
        <Fade style={{ width: '100%' }} triggerOnce delay={500}>
          <NewHomeStats />
        </Fade>
        <NewHomeTrend />
        <NewHomeAssistant />
        <NewHomeBrandList title="Partners" brands={PARTNERS} />
        <NewHomeNews />
      </Container>
    </Box>
  );
};

export default NewHome;
